import React from 'react';
import CompanyStatus from "./CompanyStatus";
import {header} from "../Url/ApiUrl";
import swal from 'sweetalert';
import {Logout} from "../Actions/Actions";
import {useTranslation} from "react-i18next";
const HeadInfo = ({user, setUser}) => {
    const { t } = useTranslation();
    const handlePdfView = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_API_ENDPOINT+'/pdf', {headers: header},{
                    method: "GET"
                });
            if (!response.ok) {
                await swal(t('error'), t('no_data_found'), "error");
                return false;
            }
            //
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            window.open(blobUrl, "_blank");
        } catch (error) {
            if(error.response?.data?.status === 401){
                Logout()
            }else{
                console.log(error)
            }
        }
    };
    return (
        <div className="col-12 py-1">
            <div className="row">
                <div className="col-12 py-2">
                    <p className="p-2 m-0 alert-info">{t('to_admin')}:
                        <a rel="noreferrer" target="_blank" href="https://t.me/+998906515225">
                            <b>{t('admin')}:<i className="bi bi-telegram"></i></b>
                        </a>
                    </p>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    {
                        user.scoreStatus ?
                            <div className="d-grid gap-2">
                                <button className="btn btn-outline-primary btn-block" onClick={handlePdfView}>
                                    {t('points_awarded')} <i className="bi bi-file-earmark-pdf-fill"></i>
                                </button>
                            </div>

                            : <p className="text-center pt-2">{t('no_score')}</p>
                    }

                </div>
                <br/><br/>
                <div className="col-12">
                    <CompanyStatus user={user} setUser={setUser} />
                </div>
            </div>
        </div>
    )
}

export default HeadInfo;